import axios from 'axios';
import * as Sentry from '@sentry/core';
import { useTenant } from '@packlink/tenant-provider';
import { useState, useEffect } from 'react';
import { TenantConfigContext } from './TenantConfigContext.js';
import { jsx } from '@emotion/react/jsx-runtime';

const TenantConfigProvider = _ref => {
  let {
    children,
    application,
    cdnUrl,
    resources
  } = _ref;
  const {
    name: tenantName
  } = useTenant();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [config, setConfig] = useState(null);
  useEffect(() => {
    if (resources) {
      setLoading(false);
      setConfig(resources);
      return;
    }
    const loadTenantsWrapperFunc = async () => {
      try {
        const {
          data
        } = await axios.get(`${cdnUrl}/tenants/${application}/${tenantName.toLowerCase()}.json`);
        setConfig(data);
      } catch (e) {
        setError(e);
        Sentry.captureException(e);
      } finally {
        setLoading(false);
      }
    };
    setLoading(true);
    setError(null);
    loadTenantsWrapperFunc();
  }, [application, cdnUrl, resources, tenantName]);
  return jsx(TenantConfigContext.Provider, {
    value: {
      config,
      loading,
      error
    },
    children: children
  });
};

export { TenantConfigProvider };
//# sourceMappingURL=TenantConfigProvider.js.map
